import request from "@/utils/request";

export function getMarquee() {
  return request({
    url: "api/marquee",
    method: "get"
  });
}
